import {
  Box,
  Button,
  Code,
  Flex,
  Spinner,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import FileUploaderPro from "../FileUploader/FIleUploaderPro";
import { useDispatch, useSelector } from "react-redux";
import { ErpConverterAPI } from "../../Redux/App/app.actions";
import { useNavigate } from "react-router-dom";
import * as types from "../../Redux/App/app.actionTypes";

const ErpConverter = ({ onSuccess }) => {
  const [erp_file, set_erp_file] = useState(null);
  const toast = useToast();
  const dispatch = useDispatch();
  const state = useSelector((state) => state.app);
  const navigate = useNavigate();
  const isLoading = state.erp_file.isLoading;

  useEffect(() => {
    console.log({ state });
  }, [state]);

  //
  const handleDownload = (fileObject) => {
    // Create a Blob containing the file data
    const blob = new Blob([fileObject], { type: "application/csv" });

    // Create a URL for the Blob
    const url = window.URL.createObjectURL(blob);

    // Create a temporary <a> element to trigger the download
    const a = document.createElement("a");
    a.href = url;
    a.download = fileObject.name; // Use the file name for the download

    // Trigger the click event on the <a> element to start the download
    a.click();

    // Clean up by revoking the Blob URL
    window.URL.revokeObjectURL(url);
  };
  //

  const handleSubmit = () => {
    if (!erp_file) {
      return toast({
        title: "No ERP file found",
        description: "Please upload the ERP file to continue",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
    dispatch(ErpConverterAPI(erp_file))
      .then((res) => {
        if (res.type === types.ERP_CONVERT_FAILURE) {
          toast({
            title: "Network error",
            description: "A network error occured while converting",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        } else if (res.type === types.ERP_CONVERT_SUCCESS) {
          onSuccess();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Flex>
      <Flex direction="column" mt="2rem" gap="2rem">
        <Box
          border={erp_file ? "2px solid #38a169" : "2px solid #FE637F"}
          borderRadius="5px"
        >
          <FileUploaderPro
            file={erp_file}
            onChange={(file) => set_erp_file((prev) => file)}
          />
        </Box>
        <Button
          colorScheme="orange"
          onClick={handleSubmit}
          disabled={isLoading}
        >
          {isLoading ? (
            <Flex gap="1rem">
              <Text>Converting</Text>
              <Spinner color="white" />
            </Flex>
          ) : (
            "Convert ERP to Data Ready"
          )}
        </Button>
      </Flex>
    </Flex>
  );
};

export default ErpConverter;
